import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  size?: 'default' | 'large';
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  size = 'default',
  className = ''
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-10 py-5 text-xl md:text-2xl' : 'px-8 py-4 text-lg md:text-xl';
  return <motion.button whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`bg-gold-accent hover:bg-gold-light text-navy-primary font-bold rounded-xl shadow-lg hover:shadow-xl transition-all ${sizeClasses} ${className}`} data-id="element-287">
      {children}
    </motion.button>;
}